import { AdaptiveDecorator, FieldsDecorator, Node, NodeTree, StylesDecorator } from "../props";
import { ActiveValue, ListOfIdentifiers, Value } from "../values";
/**
 * Visitor'ы будут знать про все типы visitables в любом случае.
 * В связи с этим было бы полезно сделать действие по умолчанию.
 */
export var VisitableClasses = {
  ActiveValue: ActiveValue,
  ListOfIdentifiers: ListOfIdentifiers,
  Value: Value,
  AdaptiveDecorator: AdaptiveDecorator,
  FieldsDecorator: FieldsDecorator,
  StylesDecorator: StylesDecorator,
  Node: Node,
  NodeTree: NodeTree
};
export var VisitableClassesMap = new Map(Object.entries(VisitableClasses).map(function (keys) {
  return keys.reverse();
}));